<template>
  <v-container fluid v-show="mostrar">
    <v-row justify="center">
      <v-col cols="12" md="8" sm="12">
        <v-card class="mx-auto">
          <v-toolbar flat color="primarytwo" dark>
            <v-toolbar-title>Cambiar Contraseña</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
          </v-toolbar>
          <v-card-text class="py-3">
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-container>
                <v-row>
                  <v-col cols="12" class="py-2">
                    <v-text-field
                      label="Contraseña Anterior"
                      counter="true"
                      v-model="defaultItem.passwordAnterior"
                      maxlength="20"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      :rules="[
                        () =>
                          !!defaultItem.passwordAnterior ||
                          'El campo es requerido',
                      ]"
                      @click:append="show1 = !show1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-2">
                    <v-text-field
                      label="Nueva Contraseña"
                      counter="true"
                      v-model="defaultItem.passwordActual"
                      maxlength="20"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show2 ? 'text' : 'password'"
                      :rules="[
                        () =>
                          !!defaultItem.passwordActual ||
                          'El campo es requerido',
                        (x) => x.length >= 4 || 'Mínimo 4 digitos',
                      ]"
                      @click:append="show2 = !show2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-2">
                    <v-text-field
                      label="Confirmar Contraseña"
                      counter="true"
                      v-model="defaultItem.passwordActualConfirma"
                      maxlength="20"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show3 ? 'text' : 'password'"
                      :rules="[
                        () =>
                          !!defaultItem.passwordActualConfirma ||
                          'El campo es requerido',
                        (x) => x.length >= 4 || 'Mínimo 4 digitos',
                      ]"
                      @click:append="show3 = !show3"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions class="py-1">
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              :loading="btnsave.loading"
              :disabled="btnsave.loading"
              @click.stop="btnSaveClick"
              >Grabar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-snackbar
          v-model="mensaje.snack"
          :timeout="mensaje.tiempo"
          :color="mensaje.snackColor"
          top
          right
        >
          {{ mensaje.snackText }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="mensaje.snack = false">
              <v-icon dark>mdi-close-box</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>



<script>
import axios from "axios";
export default {
  name: "cambiarPassword",
  components: {},
  data: () => ({
    show1: false,
    show2: false,
    show3: false,
    mostrar: true,
    mensaje: {
      snack: false,
      snackColor: "",
      snackText: "",
      tiempo: 2000,
    },
    btnsave: {
      loading: false,
    },
    form: {
      valid: true,
      deshabilita: false,
    },
    defaultItem: {
      idUsuario: 0,
      passwordAnterior: "",
      passwordActual: "",
      passwordActualConfirma: "",
    },
  }),
  watch: {},
  methods: {
    apiGuardar(data) {
      return new Promise((resolve, reject) => {
        let url = "api/Usuario/RestablecerPassword/";
        let configuracion = {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        };
        axios
          .put(
            url,
            {
              id_persona: data.id_persona,
              passwordAnterior: data.passwordAnterior,
              passwordActual: data.passwordActual,
              passwordActualConfirma: data.passwordActualConfirma,
            },
            configuracion
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async btnSaveClick() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }
        //console.log(this.$store.state.usuario);
        this.btnsave.loading = true;
        this.form.deshabilita = true;
        let data = {
          id_persona: this.$store.state.usuario.idUsuario,
          passwordAnterior: this.defaultItem.passwordAnterior,
          passwordActual: this.defaultItem.passwordActual,
          passwordActualConfirma: this.defaultItem.passwordActualConfirma,
        };
        const respuesta = await this.apiGuardar(data);
        if (respuesta) {
          this.mensaje.snackColor = "success";
          this.mensaje.snackText = "El registro fue grabado correctamente!";
          this.mensaje.snack = true;
          setTimeout(this.salir, 1000);
          //this.dialog = false;
          //this.limpiarControles();
          //this.$refs.form.resetValidation();
          //this.resolve("ok");
        }
      } catch (error) {
        if (error.response === null || error.response === undefined) {
          this.mensaje.snackColor = "colorErrorLocal";
          this.mensaje.snackText = error;
          this.mensaje.snack = true;
        } else {
          this.mensaje.snackColor = "colorErrorServer";
          this.mensaje.snackText = await this.$store.dispatch(
            "errorMensaje",
            error.response
          );
          this.mensaje.snack = true;
        }
      } finally {
        this.btnsave.loading = false;
        this.form.deshabilita = false;
      }
    },
    salir(){
      this.$store.dispatch("salir");
    }
  },
};
</script>
